/* eslint-disable import/prefer-default-export */

// Get the display name of a JSX component for dev tools
export function formatWrappedComponentDisplayName(hocName, component) {
  return `${hocName}(${component.displayName || component.name || 'Unknown'})`;
}
